/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/8/26
 * @updateTime 2021/8/26
 * @decription 保全详情 =》 请求js
 * @namespace request 命名空间
 */
import request from '@/api/axios';
export default {
    // 方法
    methods: {

        /**
         * 请求执行信息数据
         * @param {String} bqid 保全id
         * @returns {Promise}
         * */
        requestBqzrx(bqid) {
            return request({
                url:'ssbq/api/sqbq/xq/cczx',
                method:'get',
                params: {
                    time: new Date().getTime(),
                    bqid: bqid,
                },
            })
        }
    }
};
